module.exports = __webpack_public_path__ + "img/petgeek.7742cd70.jpg";